
const paths = [
  {
    label: 'Admin',
    path: '/cats/admin',
    roles: [
      'admin',
    ],
    subPaths: [
      {
        label: 'Test',
        path: 'test',
        roles: [
          'admin',
        ],
        subPaths: [],
      },
    ],
  },
  {
    label: 'Merchant',
    path: '/cats/merchant',
    roles: [
      'admin',
      'merchant',
    ],
    subPaths: [
      {
        label: 'Accession',
        path: 'accession',
        roles: [
          'admin',
          'merchant',
        ],
        subPaths: [],
      },
      {
        label: 'Assets',
        path: 'assets',
        roles: [
          'admin',
          'merchant',
        ],
        subPaths: [],
      },
      {
        label: 'Analytics',
        path: 'analytics',
        roles: [
          'admin',
          'merchant',
        ],
        subPaths: [],
      },
    ],
  },
  {
    label: 'Browse',
    path: '/cats/browse',
    roles: [
      'admin',
      'merchant',
      'user',
    ],
    subPaths: [],
  },
];

export {
  paths,
}